export const delete_recursive = (obj: any, path: any) => {
    if (typeof path === 'string') {
        path = path.split('.')
    }

    path.reduce((acc: any, key: any, index: any) => {
        // A path segment is missing — there's nothing to delete, so stop without dereferencing undefined.
        if (acc == null) {
            return acc
        }
        if (index === path.length - 1) {
            delete acc[key]
            return true
        }
        return acc[key]
    }, obj)
}
